<template>
  <div>
    <!-- Add submenu -->
    <div class="submenu mb-4">
      <button
        v-for="(item, index) in menuItems"
        :key="index"
        @click="activeView = item.value"
        :class="['menu-button', { active: activeView === item.value }]"
        :title="item.tooltip ? item.tooltip() : ''"
      >
        {{ typeof item.label === "function" ? item.label() : item.label }}
      </button>
    </div>
    <users-table v-if="activeView === 'users'"></users-table>
    <removed-users-table
      v-if="activeView === 'removed-users'"
    ></removed-users-table>
  </div>
</template>
<script>
import UsersTable from "../components/User/UsersTable.vue";
import RemovedUsersTable from "../components/User/RemovedUsersTable.vue";

export default {
  name: "UsersView",
  components: {
    UsersTable,
    RemovedUsersTable,
  },
  data() {
    return {
      activeView: "users",
      menuItems: [
        { label: "Users", value: "users" },
        { label: "Removed Users", value: "removed-users" },
      ],
    };
  },
};
</script>

<style scoped>
.submenu {
  display: flex;
  gap: 1rem;
}

.menu-button {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  width: 150px;
}

.menu-button.active {
  background: rgb(226, 225, 225);
  color: black;
  border-color: rgb(226, 225, 225);
}
</style>
